import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { languageHelper } from "../../../config/helperFunctions";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function Offer() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();

  const fetchOffers = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/offers`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user?.outlet_id,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          setData(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error("Fetch offers error:", err);
      });
  }, [user?.token, user?.user?.outlet_id]);

  useEffect(() => {
    fetchOffers();
  }, [fetchOffers]);

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/offers/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message || "Offer deleted successfully!", {
          position: "bottom-right",
          theme: "colored",
        });
        fetchOffers();
        setDeleteId(null);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to delete offer", {
          position: "bottom-right",
          theme: "colored",
        });
      });
  };

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`AddOfferForm/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => {
        setDeleteId(id);
      },
    },
  ];

  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (sn) => sn.row.index + 1,
    },
    {
      header: languageHelper("Title") || "Title",
      accessorKey: "title",
      cell: (row) => (
        <span className="font-semibold text-gray-800">
          {row.getValue() || "-"}
        </span>
      ),
    },
    {
      header: languageHelper("Product") || "Product",
      cell: (row) => (
        <span className="font-medium text-purple-700">
          {row.row.original.food_menu?.name || "-"}
        </span>
      ),
    },
    {
      header: languageHelper("Buy") || "Buy",
      accessorKey: "buy",
      cell: (row) => (
        <span className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded font-semibold text-xs">
          {row.getValue()}
        </span>
      ),
    },
    {
      header: languageHelper("Free") || "Free",
      accessorKey: "free",
      cell: (row) => (
        <span className="px-2 py-0.5 bg-green-100 text-green-800 rounded font-semibold text-xs">
          {row.getValue()}
        </span>
      ),
    },
    {
      header: languageHelper("Start Date") || "Start Date",
      accessorKey: "start_date",
    },
    {
      header: languageHelper("End Date") || "End Date",
      accessorKey: "end_date",
    },
    {
      header: languageHelper("Status") || "Status",
      accessorKey: "status",
      cell: (row) =>
        row.getValue() === "active" ? (
          <span className="bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded text-xs font-semibold">
            {languageHelper("Active")}
          </span>
        ) : (
          <span className="bg-red-100 text-red-700 px-2 py-0.5 rounded text-xs font-semibold">
            {languageHelper("Inactive")}
          </span>
        ),
    },
    {
      header: languageHelper("Actions") || "Actions",
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];

  const buttonData = [
    {
      buttonText: languageHelper("Add Offer"),
      path: "AddOfferForm",
    },
  ];

  return (
    <div>
      <CardTable
        buttonData={buttonData}
        data={data}
        columns={columns}
        heading={languageHelper("Offers (Buy N Get N Free)")}
      />

      {deleteId && (
        <div
          className="w-full h-screen grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-50"
          onClick={() => setDeleteId(null)}
        >
          <div
            className="p-6 rounded-lg bg-white max-w-md w-full space-y-4 shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className="text-red-600 font-semibold text-xl text-center">
              {languageHelper("Alert!")}
            </h1>
            <p className="text-center text-gray-700">
              {languageHelper("Are you sure you want to delete this offer?")}
            </p>

            <div className="flex justify-center gap-4 pt-2">
              <button
                onClick={() => setDeleteId(null)}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 font-medium"
              >
                {languageHelper("No")}
              </button>
              <button
                onClick={() => handleDelete(deleteId)}
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 font-medium"
              >
                {languageHelper("Yes")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Offer;
